<div class="modal-header border-bottom p-3">
  <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
    {{ "CreditMultiPayment" | translate }}
  </h6>
  <button
    type="button"
    class="btn-close-modal btn-icon btn-close"
    aria-label="Close"
    (click)="callParent('closeCredit')"
  ></button>
</div>

<div class="modal-body mx-0 flex-grow-0">
  <div class="col-12">
    <div class="add-box-item d-flex justify-content-around p-2 pb-4">
      <div class="company-selector-box col-12">
        <label for="companyName" class="form-label m-0"
          >{{ "SelectCompany" | translate }}:</label
        >
        <div class="validation-alert-sale-buy" id="CompanyName">
          <p>{{ backendJson.drugDistributorIdMessage }}</p>
        </div>
        <app-drop-down
          [dropDownData]="companyList"
          [addUrl]="'DrugDistributor'"
          [defaultValue]="this.backendJson.drugDistributorId"
          [isValid]="
            backendJson.drugDistributorIdMessage == '' ||
            backendJson.drugDistributorIdMessage == null
          "
          [buttonClass]="'Focusable'"
          (change)="getFactor()"
          (ngModelValueChange)="changeCompany($event)"
        ></app-drop-down>
        <app-loading-panel *ngIf="loading"></app-loading-panel>
      </div>
    </div>
    <div class="add-box-item d-flex flex-wrap justify-content-start mt-3 p-2" *ngIf="factorList && factorList.length > 0">
      <div class="col-12 col-lg-3 col-md-6 p-2" *ngFor="let item of factorList; let i = index">
        <button
          type="button"
          class="companyName-color"
          [ngClass]="{ 'factor-is-select': item.selected }"
          (click)="selectFactor(item, i)"
        >
          <div class="d-flex justify-content-evenly">
            <span> {{ "FactorId" | translate }}</span>
            <p>{{ item.factorId | dataType : "" }}</p>
          </div>
          <p>{{ item.totalPrice | dataType : "price" }}</p>
          <p>{{ item.factorDate | dataType : "" }}</p>
        </button>
      </div>
    </div>
    <div class="add-box-item mt-3 p-2 modal-body mx-0 flex-grow-0">
      <div class="third-box row">
        <div class="check-ui-show col-12 position-relative">
          <!-- <p class="check-date">
            {{ backendJson.factorDate | dataType : "" }}
          </p>
          <p class="check-date-character">
            {{ backendJson.factorDate | dataType : "" }}
          </p> -->
          <input
            class="check-price"
            type="text"
            [(ngModel)]="backendJson.checkPriceNumber"
            disabled
          />
          <input
            class="check-character-price"
            type="text"
            [(ngModel)]="backendJson.checkPriceNumber"
            disabled
          />
          <input
            class="check-reciver"
            type="text"
            [(ngModel)]="backendJson.checkPayTo"
            disabled
          />
          <input
            class="check-reciver-national-code"
            type="text"
            [(ngModel)]="backendJson.checkPayNationalCode"
            disabled
          />
          <input
            class="check-number"
            type="text"
            [(ngModel)]="backendJson.checkNumber"
            disabled
          />
        </div>
        <div class="col-12">
          <div
            id="accordionIcon"
            class="accordion mt-3 accordion-without-arrow"
          >
            <div class="accordion-item card">
              <h2
                class="accordion-header text-body d-flex justify-content-between"
                id="accordionIconOne"
              >
                <button
                  type="button"
                  class="accordion-button collapsed collapse-checkBook-header"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionIcon-1"
                  aria-controls="accordionIcon-1"
                >
                  {{ "CheckBook" | translate }}
                </button>
              </h2>

              <div
                id="accordionIcon-1"
                class="accordion-collapse collapse collapse-checkBook"
                data-bs-parent="#accordionIconOne"
              >
                <div class="accordion-body lh-2 row">
                  <div class="col-12 col-lg-3 col-md-6 p-0" *ngFor="let checkBook of checkBooks">
                    <div class="check-book-box p-0 my-2">
                      <button
                        type="button"
                        class="box-btn"
                        (click)="getCheck(checkBook)"
                      >
                        <div class="px-1">
                          <i class="bx bxs-book-bookmark"></i>
                        </div>
                        <span class="px-2">
                          {{ checkBook.name }}
                        </span>
                        <app-loading-panel
                          *ngIf="checkBook.loading"
                        ></app-loading-panel>
                      </button>
                      <button
                        type="button"
                        *ngFor="let check of checkBook.checks; let i = index"
                        class="btn-checkbook-check mx-2 my-1 animate__animated animate__fadeInRight"
                        [ngClass]="{
                          'btn-check-pass': check.isPassed,
                          'btn-check-use': check.paymentId != null,
                          'btn-current-use': check.isSelect
                        }"
                        [style.animation-delay]="i * 0.4 + 's'"
                        (click)="selectCheck(check)"
                      >
                        <i class="fas fa-money-check me-2"></i>
                        {{ check.checkNumber }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion-item card">
              <h2
                class="accordion-header text-body d-flex justify-content-between"
                id="accordionIconThree"
              >
                <button
                  type="button"
                  class="accordion-button collapsed collapse-check-detail-header"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionIcon-3"
                  aria-controls="accordionIcon-3"
                >
                  {{ "CheckDetail" | translate }}
                </button>
              </h2>

              <div
                id="accordionIcon-3"
                class="accordion-collapse collapse collapse-check-detail"
                data-bs-parent="#accordionIconThree"
              >
                <div class="accordion-body lh-2 row">
                  <div class="col-12 col-lg-3 col-md-6">
                    <label class="form-label" for="checkPriceNumber">
                      {{ "checkPriceNumber" | translate }}
                    </label>
                    <input
                      id="checkPriceNumber"
                      class="form-control"
                      [(ngModel)]="paymentAmount"
                      type="text"
                      mask="separator.0"
                      thousandSeparator=","
                    />
                  </div>
                  <div class="col-12 col-lg-3 col-md-6">
                    <label class="form-label" for="checkDate">
                      {{ "checkDate" | translate }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      [ngClass]="{
                        'is-invalid':
                          backendJson.factorDateMessage != '' &&
                          backendJson.factorDateMessage != null
                      }"
                      id="factorDate"
                      [ngModel]="backendJson.checkDate | dataType : '' : false"
                      [ngModelOptions]="{ standalone: true }"
                      placeholder="YYYY/MM/DD"
                      [ngbPopover]="popoverDatapickerfactorDate"
                      #datePicker="ngbPopover"
                      [autoClose]="'outside'"
                      autocomplete="disabled"
                    />

                    <ng-template #popoverDatapickerfactorDate>
                      <app-data-picker
                        [(childProp)]="backendJson.checkDate"
                        (changeVariableMonth)="changeMonth($event)"
                      ></app-data-picker>
                    </ng-template>
                  </div>
                  <div class="col-12 col-lg-3 col-md-6">
                    <label class="form-label" for="checkPayTo">
                      {{ "checkPayTo" | translate }}
                    </label>
                    <input
                      id="checkPayTo"
                      class="form-control"
                      [(ngModel)]="backendJson.reciver"
                      type="text"
                    />
                  </div>
                  <div class="col-12 col-lg-3 col-md-6">
                    <label class="form-label" for="checkPayNationalCode">
                      {{ "checkPayNationalCode" | translate }}
                    </label>
                    <input
                      id="checkPayNationalCode"
                      type="number"
                      class="form-control"
                      [(ngModel)]="backendJson.nationalCode"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer border-top p-3 justify-content-center">
  <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit">
    {{ "Submit" | translate }}
  </button>
</div>
